import { render, staticRenderFns } from "./AddAttachmentBox.vue?vue&type=template&id=787b5868"
import script from "./AddAttachmentBox.vue?vue&type=script&lang=js"
export * from "./AddAttachmentBox.vue?vue&type=script&lang=js"
import style0 from "./AddAttachmentBox.vue?vue&type=style&index=0&id=787b5868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports